'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WMHeading = function WMHeading(_ref) {
	var _ref$level = _ref.level,
	    level = _ref$level === undefined ? '1' : _ref$level,
	    style = _ref.style,
	    children = _ref.children;
	return _react2.default.createElement(
		'div',
		{ 'data-component-identifier': 'wm-heading__wrapper' },
		level === '1' && _react2.default.createElement(
			'h1',
			{ style: Object.assign({}, _styles2.default.h1, style) },
			children
		),
		level === '2' && _react2.default.createElement(
			'h2',
			{ style: Object.assign({}, _styles2.default.h2, style) },
			children
		),
		level === '3' && _react2.default.createElement(
			'h3',
			{ style: Object.assign({}, _styles2.default.h3, style) },
			children
		),
		level === '4' && _react2.default.createElement(
			'h4',
			{ style: Object.assign({}, _styles2.default.h4, style) },
			children
		)
	);
};

exports.default = WMHeading;


// WEBPACK FOOTER //
// ./~/@workmarket/front-end-components/dist/WMHeading/index.js